<script setup>
import { ref, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import GenericTooltip from '../../common/GenericTooltip.vue';
import GenericAlert from '../../common/GenericAlert.vue';
import GenericProgressCircle from '../../common/GenericProgressCircle.vue';
import { usePortAllData } from '@/stores/portAllData'
import { storeToRefs } from 'pinia'
import { DateTime } from 'luxon'

const store = usePortAllData()
const { getUlhMessages } = storeToRefs(store)

const { t } = useI18n()
const logTrackingDialog = ref(false)
const logContainer = ref()

const openLogTracking = () => {
  logTrackingDialog.value = true
}

const closeLogTracking = () => {
  logTrackingDialog.value = false
}

const formatTime = (timestamp) => {
  if (timestamp) return DateTime.fromMillis(timestamp).toFormat('dd/MM/yyyy HH:mm:ss')
  return ''
}

watch(getUlhMessages, async (nv) => {
  await nextTick()
  if (logContainer.value) {
    logContainer.value.scrollTop = logContainer.value.scrollHeight
  }
}, { deep: true })
</script>

<template>
  <div class="ulhysses-log-tracking">
    <generic-tooltip :text="t('log-monitoring')" position="top">
      <button @click="openLogTracking">
        <i class="icon-ulhysses" />
      </button>
    </generic-tooltip>
  </div>

  <Teleport to="body">
    <generic-alert
      :title="t('log-monitoring')"
      :alert-active="logTrackingDialog"
      :confirm-text="t('close-log-tracking')"
      :show-cancel-button="false"
      @confirm-alert="closeLogTracking"
    >
      <div ref="logContainer" class="ulhysses-logs-tracking-dialog">
        <div v-for="log in getUlhMessages" :key="log.id" class="log-line">
          <div>
            {{ formatTime(log.timestamp) }}
          </div>
          <div>
            {{ log.msg }}
          </div>
          <div class="progress-line">
            <generic-progress-circle v-if="log.type === 'progress'" :progress="log.progress" :completed="log.completed" />
            <generic-progress-circle v-else :progress="0" completed />
          </div>
        </div>
      </div>
    </generic-alert> 
  </Teleport>
</template>

<i18n src="@/locales/ulhysses.json"></i18n>